import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Topic} from "../../../../domain/topic";
import {TopicService} from "../../../../service/forum/topic.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../../../core/service/user.service";
import {SelectItem} from "primeng/components/common/api";
import {ActivatedRoute, Router} from "@angular/router";
import {MessageSeverity} from "../../../../../core/commons/message-severity";
import {Role} from "../../../../../core/domain/role";
import {GlobalAppService} from "../../../../../core/commons/global-app.service";

@Component({
    selector: 'topic-form',
    templateUrl: './topic-form.component.html',
    styleUrls: ['./topic-form.component.scss'],
    providers: [TopicService, UserService]
})
export class TopicFormComponent implements OnInit {

    public topic: Topic = new Topic();

    public title: string = "";

    public update : boolean = false;

    public topicForm: FormGroup;

    public mediators: SelectItem[] = [{label: "Selecciona una opción", value: null}];


    constructor(private messageService: GlobalAppService,
                private topicService: TopicService,
                private formBuilder: FormBuilder,
                private userService: UserService,
                private route: ActivatedRoute,
                private location: Location) {

        this.topicForm = this.formBuilder.group({
            id: [null],
            name: ['', Validators.required],
            mediator: ['', Validators.required]
        });
    }

    ngOnInit() {
        //TODO: Recuperar el rol  desde la base
        this.userService.findByRole( new Role({id : 13}))
            .map(users =>
                users.map(u => ({label: u.firstname +" "+u.lastname, value: u}))
            )
            .subscribe(users => {
                this.mediators = this.mediators.concat(users);
            });

        let id = this.route.params
            .map(params => params['id']);

        id.filter(id => id != 'new')
            .switchMap(id => this.topicService.get(+id))
            .subscribe(t => {
                this.title = "Editar el tópico";
                this.update = true;
                this.topic = t;
                this.topicForm.get("id").setValue(this.topic.id);
                this.topicForm.get("name").setValue(this.topic.name);
                this.topicForm.get("mediator").setValue(this.topic.mediator);
            });

        id.filter(id => id == 'new')
            .subscribe(id => {
                this.topic = new Topic();
                this.title = "Nuevo tópico";
            });

    }

    public save( { value, valid } ){
        if ( valid ) {
            if( !this.update ) {
                this.topicService.create(new Topic(value)).subscribe(
                t => {
                    this.messageService.sendMsg(MessageSeverity.SUCCESS, "Creado",
                        "El tópico se creó con éxito.");
                    this.goBack();
                },
                error => {
                    this.messageService.sendMsg(
                        MessageSeverity.ERROR,
                        "Error:",
                        "No sé a podido crear el tópico."
                    )
                });
            } else {
                this.topicService.update(new Topic(value)).subscribe(
                    t => {
                        this.messageService.sendMsg(MessageSeverity.SUCCESS, "Creado",
                            "El tópico se modifico correctamente.");
                        this.goBack();
                    },
                    error => {
                        this.messageService.sendMsg(
                            MessageSeverity.ERROR,
                            "Error:",
                            "No sé a podido modificar el tópico."
                        )
                    });
            }

        }
    }

    public goBack() {
        this.location.back();
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/topic/topic-form/topic-form.component.ts